import React from 'react';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import CallHistory from '../../components/page-components/call-activity/CallHistory';

const CallActivity = () => {
    return (
        <MenuContainer>
            <CallHistory />
        </MenuContainer>
    );
};

export default CallActivity;
